import { useEffect, useState } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import { connect, useDispatch, useSelector } from "react-redux";
import { InboxOutlined, FilePdfOutlined, FileWordOutlined, FileOutlined } from "@ant-design/icons";

import { Form as FormAnt, Upload } from "antd";
import { formatDate3, formatNewDate } from "../../../../../utils/utils";

import { gestionService } from "../../../../../_services/gestionLegal.service";
import { getTipoEtapas } from "../../../../../redux/Sections/Estados/actions";


import Swal from "sweetalert2";

import { setLoading } from "../../../../../redux/Loading/actions";

const EditActuacion = ({ show, handleClose, actuacion, action, filters }) => {
  const {
    tipoEtapas
  } = useSelector(e => e.dashboard);
  const dispatch = useDispatch();

  // const [modos, setModos] = useState([]);
  const [files, setFiles] = useState([]);
  const [actuacionType, setActuacionType] = useState({
    name: "",
    select: false,
  });

  const {
    register,
    reset,
    // setValue,
    handleSubmit,
    control,
    formState: { errors },
  } = useForm({
    defaultValues: actuacion,
  });

  useEffect(() => {
    if (actuacion) {
      dispatch(getTipoEtapas(actuacion.gp_id));
    }
  }, [actuacion]);

  useEffect(() => {
    const getData = async () => {
      try {
        dispatch(setLoading(true));
        let response = await gestionService.getActuacion(actuacion.id);

        reset({
          ...response,
          fecha: formatDate3(response.fecha)
        });

        if (response.dato) {
          let datos = JSON.parse(response?.dato);
          if (datos?.length) {
            reset({
              ...response,
              fecha: formatDate3(response.fecha),
              ...datos[0]
            });

          }
        }
        dispatch(setLoading(false));
      }
      catch (err) {
        console.log("err", err);
        dispatch(setLoading(false));
      }
    };

    getData();

    return () => {
      // setActuacion("");
    };
  }, [actuacion]);

  useEffect(() => {
    reset({
      tp_id: actuacion?.tp_id,
      fecha: formatNewDate()
    });

    setActuacionType({
      name: actuacion?.tp_id,
      select: true,
    });
  }, [actuacion]);

  const onSubmit = async (data) => {
    Swal.fire({
      title: "¿Esta seguro de guardar los cambios?",
      icon: "warning",
      showCancelButton: true,
      cancelButtonText: "No",
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si",
      reverseButtons: true,
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          data.files = files;

          data.abogado = actuacion?.codexterno;

          if (data.monto) {
            data.monto = data.monto.toString().replace(",", ".");
          }
          if (data.valor) {
            data.valor = data.valor.toString().replace(",", ".");
          }

          data.cp8480 = data.cp8480 ? 1 : 0;
          data.cpantprv = data.cpantprv ? 1 : 0;

          data.proceso = "M";
          data.id_etapa = actuacion.id;

          dispatch(setLoading(true));
          let response = await gestionService.createActuacion(data);

          if (typeof response[0] === "string") {
            dispatch(setLoading(false));
            Swal.fire("Error!", "Ocurrio un error, intentelo nuevamente.", "error");
          }
          else {
            await action(filters);
            dispatch(setLoading(false));
            Swal.fire({
              title: "Exito!",
              text: "Las actuaciones se grabarón correctamente.",
              icon: "success",
              didClose: () => handleClose()
            });
          }
        }
        catch (err) {
          console.log(err);
          dispatch(setLoading(false));
          Swal.fire("Error!", "Ocurrio un error, intentelo nuevamente.", "error");
        }
      }
    });
  };

  const normFile = (e) => {
    setFiles(e.fileList);
    if (Array.isArray(e)) {
      return e;
    }
    return e && e.fileList;
  };

  if (actuacion?.gp_id === "2") {
    return (
      <Modal
        animation={false}
        show={show}
        onHide={handleClose}
        size="xl"
        className="actuaciones-modal"
      >
        <Form className="actuaciones-form" style={{ margin: 50 }} onSubmit={handleSubmit(onSubmit)} >
          <h5 className="ml-3 mb-4">{actuacion?.nombre}</h5>
          <Row>
            <Col md={4} className="d-flex align-items-center">
              <Form.Label className="actuacion-label">Fecha</Form.Label>
            </Col>
            <Col>
              <Form.Control
                name="fecha"
                type="date"
                className={`${errors.fecha ? "is-invalid" : ""}`}
                {...register("fecha", { required: "La fecha es obligatoria" })}
                disabled={actuacion?.show}
              />
              <Form.Control.Feedback type="invalid">{errors.fecha?.message}</Form.Control.Feedback>
            </Col>
          </Row>
          <Row>
            <Col md={4} className="d-flex align-items-center">
              <Form.Label className="actuacion-label">Tipo Actuación</Form.Label>
            </Col>
            <Col>
              <Form.Control
                name="tp_id"
                as="select"
                className={`${errors.tp_id ? "is-invalid" : ""}`}
                {...register("tp_id", { required: "El tipo de etapa es obligatorio" })}
                disabled
              >
                <option value="">Seleccioné un tipo</option>
                {tipoEtapas?.length ? tipoEtapas.filter(e => e.show).map(e => {
                  return (
                    <option value={e.tipo} key={e.tipo} >{e.nombre}</option>
                  );
                }) : ""}
                
              </Form.Control>
              <Form.Control.Feedback type="invalid">{errors.tp_id?.message}</Form.Control.Feedback>
            </Col>
          </Row>
          <Row>
            <Col md={4} className="d-flex align-items-center">
              <Form.Label className="actuacion-label">Observaciones</Form.Label>
            </Col>
            <Col>
              <Form.Control
                name="obs"
                as="textarea"
                rows="6"
                {...register("obs")}
                disabled={actuacion?.show}
              />
            </Col>
          </Row>

          <div className="mt-5">
            <FormAnt.Item>
              <Form.Label className="mb-2 actuacion-label">Subir archivos:</Form.Label>
              <FormAnt.Item name="dragger" valuePropName="fileList" getValueFromEvent={normFile} noStyle>
                <Upload.Dragger
                  multiple
                  beforeUpload={() => false}
                  name="files"
                  listType="picture"
                  iconRender={(f) => {
                    console.log(f);
                    if (f.type === "application/pdf") {
                      return <FilePdfOutlined style={{ color: "#FA0F00" }} />;
                    }
                    else if ((f.type === "application/msword") || (f.type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document")) {
                      return <FileWordOutlined style={{ color: "#185ABD" }} />;
                    }
                    else {
                      return <FileOutlined />;
                    }
                  }}
                  disabled={actuacion?.show}
                >
                  <p className="ant-upload-drag-icon">
                    <InboxOutlined />
                  </p>
                  <p className="ant-upload-text">Haga click o arrastre el archivo a esta área para cargarlo</p>
                  <p className="ant-upload-hint">Soporte para una carga única o masiva.</p>
                </Upload.Dragger>
              </FormAnt.Item>
            </FormAnt.Item>
          </div>

          <Row className="justify-content-center">
            <Button
              type="submit"
              className="d-flex align-items-center ml-2"
              disabled={actuacion?.show}
            >
              Grabar Actuación
            </Button>
            <Button
              className="d-flex align-items-center ml-2"
              variant="danger"
              onClick={() => handleClose()}
            >
              Cancelar
            </Button>
          </Row>
        </Form>
      </Modal>
    );
  }

  return (
    <Modal
      animation={false}
      show={show}
      onHide={handleClose}
      size="xl"
    >
      <Form className="actuaciones-form" style={{ margin: 50 }} onSubmit={handleSubmit(onSubmit)}>
        <h5 className="ml-3 mb-4">{actuacion?.nombre}</h5>
        <Row>
          <Col md={4} className="d-flex align-items-center">
            <Form.Label className="actuacion-label">Tipo Actuación</Form.Label>
          </Col>
          <Col>
            <Form.Control
              name="tp_id"
              className={`${errors.tp_id ? "is-invalid" : ""}`}
              as="select"
              {...register("tp_id", { required: "El tipo de actuación es requerido." })}
              disabled
            >
              <option value="">Seleccioné un tipo</option>
              {tipoEtapas?.length ? tipoEtapas.map(e => {
                return (
                  <option value={e.tipo} key={e.tipo} >{e.nombre}</option>
                );
              }) : ""}
            </Form.Control>
            <Form.Control.Feedback type="invalid">{errors.tp_id?.message}</Form.Control.Feedback>
          </Col>
        </Row>
        <Row>
          <Col md={4} className="d-flex align-items-center">
            <Form.Label className="actuacion-label">
              {
                +actuacionType.name === 1 ? "Fecha de Inicio" :
                  +actuacionType.name === 3 ? "Fecha de Presentación" :
                    +actuacionType.name === 4 ? "Fecha de Dictado de Sentencia" :
                      +actuacionType.name === 5 ? "Fecha de Presentación" :
                        "Fecha"
              }
            </Form.Label>
          </Col>
          <Col className={`${actuacionType.select ? "" : "mb-3"}`}>
            <Form.Control
              name="fecha"
              type="date"
              className={`${errors.fecha ? "is-invalid" : ""}`}
              {...register("fecha", { required: "La fecha es requerida." })}
              disabled={actuacion?.show}
            />
            <Form.Control.Feedback type="invalid">{errors.fecha?.message}</Form.Control.Feedback>
          </Col>
        </Row>

        {actuacionType.select ?
          <>
            {+actuacionType.name === 1 ?
              <>
                <Row>
                  <Col md={4} className="d-flex align-items-center">
                    <Form.Label className="actuacion-label">Carátula</Form.Label>
                  </Col>
                  <Col>
                    <Form.Control
                      name="caratula"
                      className={`${errors.caratula ? "is-invalid" : ""}`}
                      {...register("caratula", { required: "La caratula es requerida." })}
                      disabled={actuacion?.show}
                    />
                    <Form.Control.Feedback type="invalid">{errors.caratula?.message}</Form.Control.Feedback>
                  </Col>
                </Row>
                <Row>
                  <Col md={4} className="d-flex align-items-center">
                    <Form.Label className="actuacion-label">Nro de Expte</Form.Label>
                  </Col>
                  <Col>
                    <Form.Control
                      name="nroexpte"
                      className={`${errors.nroexpte ? "is-invalid" : ""}`}
                      {...register("nroexpte", { required: "El número de expediente es requerido." })}
                      disabled={actuacion?.show}
                    />
                    <Form.Control.Feedback type="invalid">{errors.nroexpte?.message}</Form.Control.Feedback>
                  </Col>
                </Row>
                <Row>
                  <Col md={4} className="d-flex align-items-center">
                    <Form.Label className="actuacion-label">Nro de Título Ejecutivo</Form.Label>
                  </Col>
                  <Col>
                    <Form.Control
                      name="nrotit"
                      className={`${errors.nrotit ? "is-invalid" : ""}`}
                      {...register("nrotit", { required: "El número de titulo ejecutivo es requerido." })}
                      disabled={actuacion?.show}
                    />
                    <Form.Control.Feedback type="invalid">{errors.nrotit?.message}</Form.Control.Feedback>
                  </Col>
                </Row>
                <Row>
                  <Col md={4} className="d-flex align-items-center">
                    <Form.Label className="actuacion-label">Juzgado que interviene</Form.Label>
                  </Col>
                  <Col>
                    <Form.Control
                      name="juzgado"
                      className={`${errors.juzgado ? "is-invalid" : ""}`}
                      {...register("juzgado", { required: "El juzgado es requerido." })}
                      disabled={actuacion?.show}
                    />
                    <Form.Control.Feedback type="invalid">{errors.juzgado?.message}</Form.Control.Feedback>
                  </Col>
                </Row>
                <Row>
                  <Col md={4} className="d-flex align-items-center">
                    <Form.Label className="actuacion-label">Monto</Form.Label>
                  </Col>
                  <Col>
                    <Controller
                      control={control}
                      name="monto"
                      render={({ field: { value, onChange } }) => {
                        return (
                          <Form.Control
                            className={`${errors.monto ? "is-invalid" : ""}`}
                            onChange={(e) => {
                              let result = e.target.value.replace(/[^0-9,]/g, "").replace(/(\..*?)\..*/g, "$1");
                              let parts = result.split(",");

                              if ((parts[1] && parts[1].length > 2) || parts.length > 2) {
                                return onChange(value);
                              }
                              else {
                                return onChange(result);
                              }
                            }}
                            value={value ? value : ""}
                          />
                        );
                      }}
                      rules={{ required: "El monto es requerido." }}
                    />
                    <Form.Control.Feedback type="invalid">{errors.monto?.message}</Form.Control.Feedback>
                  </Col>
                </Row>
                <Row className="mb-3 mt-3">
                  <Col md={4} className="d-flex align-items-center">
                    <Form.Label className="actuacion-label">Cumplimiento con pago de Bono Ley 8480</Form.Label>
                  </Col>
                  <Col>
                    <Form.Check
                      name="cp8480"
                      {...register("cp8480")}
                      disabled={actuacion?.show}
                    />
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md={4} className="d-flex align-items-center">
                    <Form.Label className="actuacion-label">Cumplimiento con pago Anticipo Previsional</Form.Label>
                  </Col>
                  <Col>
                    <Form.Check
                      name="cpantprv"
                      {...register("cpantprv")}
                      disabled={actuacion?.show}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col md={4} className="d-flex align-items-center">
                    <Form.Label className="actuacion-label">Períodos que abarca</Form.Label>
                  </Col>
                  <Col>
                    <Form.Control
                      name="periodos"
                      className={`${errors.periodos ? "is-invalid" : ""}`}
                      {...register("periodos", { required: "El periodo que abarca es requerido." })}
                      disabled={actuacion?.show}
                    />
                    <Form.Control.Feedback type="invalid">{errors.periodos?.message}</Form.Control.Feedback>
                  </Col>
                </Row>
              </>
              : null}


            {+actuacionType.name === 2 ?
              <>
                <Row className="mt-3" >
                  <Col md={4} className="d-flex align-items-center">
                    <Form.Label className="actuacion-label">Resultado</Form.Label>
                  </Col>
                  <Col>
                    <Form.Check
                      type="radio"
                      label="Positivo"
                      name="resultado"
                      className={`d-flex align-items-end ${errors.resultado ? "is-invalid" : ""}`}
                      value="0"
                      {...register("resultado", { required: "El resultado es requerido." })}
                      disabled={actuacion?.show}
                    />
                  </Col>
                  <Col>
                    <Form.Check
                      type="radio"
                      label="Negativo"
                      name="resultado"
                      className={`d-flex align-items-end ${errors.resultado ? "is-invalid" : ""}`}
                      value="1"
                      {...register("resultado", { required: "El resultado es requerido." })}
                      disabled={actuacion?.show}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col md={4}></Col>
                  <Col>
                    {errors.resultado ? (
                      <div
                        className="invalid"
                        style={{
                          fontSize: "80%",
                          color: "#dc3545"
                        }}
                      >
                        El resultado es requerido.
                      </div>
                    ) : ""}
                  </Col>
                </Row>
              </>
              : null}

            {+actuacionType.name === 3 ?
              <>
                <Row>
                  <Col md={4} className="d-flex align-items-center">
                    <Form.Label className="actuacion-label">Tipo de Medida</Form.Label>
                  </Col>
                  <Col>
                    <Form.Control
                      name="tipomedida"
                      className={`${errors.tipomedida ? "is-invalid" : ""}`}
                      {...register("tipomedida", { required: "El tipo de medida es requerido." })}
                      disabled={actuacion?.show}
                    />
                    <Form.Control.Feedback type="invalid">{errors.tipomedida?.message}</Form.Control.Feedback>
                  </Col>
                </Row>
                <Row>
                  <Col md={4} className="d-flex align-items-center">
                    <Form.Label className="actuacion-label">Resultado de la medida</Form.Label>
                  </Col>
                  <Col>
                    <Form.Control
                      name="resultado"
                      as="textarea"
                      className={`${errors.resultado ? "is-invalid" : ""}`}
                      rows={4}
                      {...register("resultado", { required: "El resultado es requerido." })}
                      disabled={actuacion?.show}
                    />
                    <Form.Control.Feedback type="invalid">{errors.resultado?.message}</Form.Control.Feedback>
                  </Col>
                </Row>
              </>
              : null}

            {+actuacionType.name === 4 ?
              <>
                <Row>
                  <Col md={4} className="d-flex align-items-center">
                    <Form.Label className="actuacion-label">Fecha de Notificación de Sentencia</Form.Label>
                  </Col>
                  <Col>
                    <Form.Control
                      name="notifsent"
                      type="date"
                      className={`${errors.notifsent ? "is-invalid" : ""}`}
                      {...register("notifsent", { required: "La fecha es requerida." })}
                      disabled={actuacion?.show}
                    />
                    <Form.Control.Feedback type="invalid">{errors.notifsent?.message}</Form.Control.Feedback>

                  </Col>
                </Row>
              </>
              : null}

            {+actuacionType.name === 5 ?
              <>
                <Row>
                  <Col md={4} className="d-flex align-items-center">
                    <Form.Label className="actuacion-label">Tipo de Medida Ejecutiva</Form.Label>
                  </Col>
                  <Col>
                    <Form.Control
                      name="tipomedida"
                      className={`${errors.tipomedida ? "is-invalid" : ""}`}
                      {...register("tipomedida", { required: "El tipo de medida es requerido." })}
                      disabled={actuacion?.show}
                    />
                    <Form.Control.Feedback type="invalid">{errors.tipomedida?.message}</Form.Control.Feedback>
                  </Col>
                </Row>
                <Row>
                  <Col md={4} className="d-flex align-items-center">
                    <Form.Label className="actuacion-label">Resultado de la medida</Form.Label>
                  </Col>
                  <Col>
                    <Form.Control
                      name="resultado"
                      as="textarea"
                      className={`${errors.resultado ? "is-invalid" : ""}`}
                      rows={4}
                      {...register("resultado", { required: "El resultado es requerido." })}
                      disabled={actuacion?.show}
                    />
                    <Form.Control.Feedback type="invalid">{errors.resultado?.message}</Form.Control.Feedback>
                  </Col>
                </Row>
              </>
              : null}

            {+actuacionType.name === 6 ?
              <>
                {/* <Row>
                  <Col md={4} className="d-flex align-items-center">
                    <Form.Label className="actuacion-label">Modo</Form.Label>
                  </Col>
                  <Col>
                    <Controller
                      control={control}
                      name="modo"
                      render={({ field: { onChange } }) => {
                        return (
                          <ReactSelect
                            onChange={(e) => onChange(e?.value)}
                            options={modos}
                          />
                        );
                      }}
                      rules={{ required: "El modo es requerido." }}
                    />
                    <Form.Control.Feedback type="invalid">{errors.modo?.message}</Form.Control.Feedback>
                  </Col>
                </Row> */}
                <Row>
                  <Col md={4} className="d-flex align-items-center">
                    <Form.Label className="actuacion-label">Valor</Form.Label>
                  </Col>
                  <Col>
                    <Controller
                      control={control}
                      name="valor"
                      render={({ field: { value, onChange } }) => {
                        return (
                          <Form.Control
                            className={`${errors.valor ? "is-invalid" : ""}`}
                            onChange={(e) => {
                              let result = e.target.value.replace(/[^0-9,]/g, "").replace(/(\..*?)\..*/g, "$1");
                              let parts = result.split(",");

                              if ((parts[1] && parts[1].length > 2) || parts.length > 2) {
                                return onChange(value);
                              }
                              else {
                                return onChange(result);
                              }
                            }}
                            value={value}
                            disabled={actuacion?.show}
                          />
                        );
                      }}
                      rules={{ required: "El valor es requerido." }}
                    />
                    <Form.Control.Feedback type="invalid">{errors.valor?.message}</Form.Control.Feedback>
                  </Col>
                </Row>
              </>
              : null}

            <Row className="mt-3">
              <Col md={4} className="d-flex align-items-center">
                <Form.Label className="actuacion-label">Observaciones</Form.Label>
              </Col>
              <Col>
                <Form.Control
                  name="obs"
                  as="textarea"
                  rows="6"
                  {...register("obs")}
                  disabled={actuacion?.show}
                />
              </Col>
            </Row>

            <div className="mt-5">
              <FormAnt.Item>
                <Form.Label className="mb-2 actuacion-label">Subir archivos:</Form.Label>
                <FormAnt.Item name="dragger" valuePropName="fileList" getValueFromEvent={normFile} noStyle>
                  <Upload.Dragger
                    multiple
                    beforeUpload={() => false}
                    name="files"
                    listType="picture"
                    iconRender={(f) => {
                      if (f.type === "application/pdf") {
                        return <FilePdfOutlined style={{ color: "#FA0F00" }} />;
                      }
                      else if ((f.type === "application/msword") || (f.type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document")) {
                        return <FileWordOutlined style={{ color: "#185ABD" }} />;
                      }
                      else {
                        return <FileOutlined />;
                      }
                    }}
                    disabled={actuacion?.show}
                  >
                    <p className="ant-upload-drag-icon">
                      <InboxOutlined />
                    </p>
                    <p className="ant-upload-text">Haga click o arrastre el archivo a esta área para cargarlo</p>
                    <p className="ant-upload-hint">Soporte para una carga única o masiva.</p>
                  </Upload.Dragger>
                </FormAnt.Item>
              </FormAnt.Item>
            </div>
          </>
          : null}

        <Row className="justify-content-center">
          <Button
            type="submit"
            className="d-flex align-items-center ml-2"
            disabled={actuacion?.show}
          >
            Guardar cambios
          </Button>
          <Button
            className="d-flex align-items-center ml-2"
            variant="danger"
            onClick={() => handleClose()}
          >
            Cancelar
          </Button>
        </Row>
      </Form>
    </Modal>
  );
};

const mapStateToProps = (state) => {
  return {
    data: state.dashboard.data
  };
};

export default connect(mapStateToProps, null)(EditActuacion);